import React, { useEffect, useState } from "react";

// MUI
import { Typography, Button } from "@mui/material";

// custom component
import ScrollableCard from "../../components/homepage/horizontalScrollCard/ScrollableCard";
import ScrollableCardCircle from "../../components/homepage/horizontalScrollCircleCard/ScrollableCardCircle";
import ParallelCard from "../../components/homepage/parallelCard/ParallelCard";
import HorizontalScrollSlider from "../../components/homepage/horizontalScrollSlider/HorizontalScrollSlider";

// loading state
import Loading from "../../components/loading";
import HomePageSkeleton from "../../components/skeletonLoading/HomePageSkeleton";

import FlatList from "../../components/FlatList";

// custom context
import { useNavbar } from "../../context/NavBarContext";

import { NotFound } from "../error/NotFound_404";

import {
  useFetchHomeDataQuery,
  // useLazyFetchDataQuery
} from "../../api/homepageApi";
import useModal from "../../hooks/useModel";
import { useNavigate } from "react-router";

const Index = () => {
  const navigate = useNavigate();
  const [Modal, openModal, closeModal, onCloseCustom] = useModal();
  const Navbar = useNavbar();

  // const info_text = JSON.parse(localStorage.getItem("infobox_text"));
  const info_box = JSON.parse(localStorage.getItem("infobox"));
  // const lines = info_text.split("\n");

  Navbar.reset();



  useEffect(() => {
    if (info_box == 1) {
      openModal();
      localStorage.setItem("infobox", JSON.stringify(0));
    }
  }, [info_box]);

  const { data, error, isLoading, isFetching } = useFetchHomeDataQuery();

  if (isLoading) {
    return <HomePageSkeleton />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  const modalBody = (
    <div className="text-center leading-5">
      {/* {lines.map((line, index) => (
        <Typography
          key={index}
          variant="body1"
          component="div"
          lineHeight={2}
          fontWeight="bold"
        >
          {line}
        </Typography>
      ))} */}
    </div>
  );

  const handleSubscribeConfirmed = () => {
    navigate("/account/my-account");
    closeModal();
  };

  const handleCanceled = () => {
    closeModal();
  };

  const modalActions = (
    <div className="flex items-center justify-center w-full mb-3">
      <Button
        size="small"
        variant="contained"
        disableRippl
        onClick={handleSubscribeConfirmed}
        sx={{
          marginTop: "20px",
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingRight: "50px",
          paddingLeft: "50px",
          borderTopLeftRadius: "10px",
          borderBottomLeftRadius: "10px",
          borderTopRightRadius: "10px",
          borderBottomRightRadius: "10px",
          backgroundColor: "#facc15",
          color: "black",
          fontWeight: "600",
          "&:hover": {
            backgroundColor: "#eab308",
            borderColor: "#eab308",
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
            backgroundColor: "#facc15",
            borderColor: "#ca8a04",
          },
        }}
      >
        ဝန်ဆောင်မှုရယူမည်
      </Button>
    </div>
  );

  return (
    <>
      <FlatList
        data={data?.result}
        renderItem={(item, index) => {
          switch (item.category_ui) {
            case 1:
              return (
                <ScrollableCard
                  key={index}
                  data={item.items}
                  title={item.category}
                  category_id={item.category_id}
                  category_type={item.category_type}
                />
              );
            case 3:
              return (
                <ScrollableCardCircle
                  key={index}
                  data={item.items}
                  title={item.category}
                  category_id={item.category_id}
                  category_type={item.category_type}
                />
              );
            case 4:
              return (
                <HorizontalScrollSlider
                  key={index}
                  data={item.items}
                  title={item.category}
                  category_id={item.category_id}
                  category_type={item.category_type}
                />
              );
            case 5:
              return (
                <ParallelCard
                  key={index}
                  data={item.items}
                  title={item.category}
                  category_id={item.category_id}
                  category_type={item.category_type}
                />
              );
            default:
              return "";
          }
        }}
      />

      <Modal
        title=""
        body={modalBody}
        actions={modalActions}
        isCloseCustom={true}
        onCloseCustom={handleCanceled}
      />
    </>
  );
};

export default Index;
